<template>
  <div id="mapa-container">
    <div id="dvMapaAppT"></div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, provide, ref, nextTick } from "vue";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Top } from "../js/class/Top.js";
import { LadzoConsole as Lc } from "../js/global/ladzo-console.js";

const map = ref(null);

// Inicializace mapy
onMounted(() => {
  Lc.f("Leaflet mapa z Vue");

  const mapInstance = L.map("dvMapaAppT", {
    zoomAnimation: false,
  }).setView([49.8, 15.5], 8);

  map.value = mapInstance;

  const API_KEY = Top.mapy_cz_api_key;
  Lc.log("API_KEY", API_KEY);
  const tileLayers = {
    "Základní mapa": L.tileLayer(
      `https://api.mapy.com/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=${API_KEY}`,
      {
        minZoom: 0,
        maxZoom: 19,
        attribution:
          '<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
      }
    ),
    "Turistická mapa": L.tileLayer(
      `https://api.mapy.com/v1/maptiles/outdoor/256/{z}/{x}/{y}?apikey=${API_KEY}`,
      {
        minZoom: 0,
        maxZoom: 19,
        attribution:
          '<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
      }
    ),
    "Zimní mapa": L.tileLayer(
      `https://api.mapy.com/v1/maptiles/winter/256/{z}/{x}/{y}?apikey=${API_KEY}`,
      {
        minZoom: 0,
        maxZoom: 19,
        attribution:
          '<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
      }
    ),
    "Letecká mapa": L.tileLayer(
      `https://api.mapy.com/v1/maptiles/aerial/256/{z}/{x}/{y}?apikey=${API_KEY}`,
      {
        minZoom: 0,
        maxZoom: 19,
        attribution:
          '<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
      }
    ),
  };

  tileLayers["Turistická mapa"].addTo(mapInstance);
  L.control.layers(tileLayers).addTo(mapInstance);
});
</script>

<style scoped>
#dvMapaAppT {
  height: 100vh;
}
</style>
